module.exports = __webpack_public_path__ + "img/3.99ff8eac.jpg";